import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", {
        "stroke-linejoin": "round",
        d: "m9.125 14.125 2.5 2.5 6.25-6.25"
      }),
      _createElementVNode("path", { d: "M7.25 2.672A12.44 12.44 0 0 1 13.5 1C20.404 1 26 6.596 26 13.5S20.404 26 13.5 26 1 20.404 1 13.5c0-2.277.609-4.411 1.672-6.25" })
    ], -1)
  ]))]))
}
export default { render: render }